import { render, staticRenderFns } from "./SponsorDetail.vue?vue&type=template&id=73040bf7"
import script from "./SponsorDetail.vue?vue&type=script&lang=js"
export * from "./SponsorDetail.vue?vue&type=script&lang=js"
import style0 from "./SponsorDetail.vue?vue&type=style&index=0&id=73040bf7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports